export const pdfViewerId = "pdf-viewer";
